<template>
    <div class="shopDetailWrap">
        <div class="shopDetailHeader">
            <!-- <img @click="goBack" src="../assets/back.png" alt=""> -->
            商品详情
        </div>
        <div class="shopDetailCont">
            <mt-swipe class="swiperWrap" :auto="2000">
                <mt-swipe-item v-for="(item,index) in swiper" :key='index'>
                    <img :src="item.picUrl" alt="">
                </mt-swipe-item>
            </mt-swipe>
            <!-- <img src="../assets/lz.jpg" alt=""> -->
            <div class="equityChoose">
                <p>权益选择</p>
                <ul>
                    <!-- <li @click="chooseEq(index)" :style="{'background':eqID==index?'#29B773':'#fff','color':eqID==index?'#fff':'#000'}" >{{itemInfo.num}}</li> -->
                    <li style="background:#29B773;color: #fff" >{{itemInfo.num}}</li>
                </ul>
            </div>

            <div class="equityZF">
                <div v-show="weixin" class="wxs">
                    <img src="../assets/weixin2.png" alt="">
                    <input id="item2" type="radio" :checked='weixin' name="item" value="选项二">
                    <label for="item2"></label>
                </div>
                <div v-show="noweixin" class="cs">
                    <img src="../assets/zhifubao.png" alt="">
                    <input id="item2" type="radio" :checked='noweixin' name="item" value="选项二">
                    <label for="item2"></label>
                </div>
            </div>
            <div class="eqInfo">
                <h4>订购规则：</h4>
                <p>
                   购买后90天内有效
                </p><p>
                   本权益商品，每日限购一次
                </p>
                <h4>会员使用：</h4>
                 <p>
                    <span>
                        1、山东移动尊享会员在线完成订单支付后，可在“我的”-“我的订单”-“额度购”中查看购买的卡券；
                    </span>
                    <span>
                        2、用户持卡券详情中的“条形码”前往山东省内中石化便利店领取商品
                    </span>
                    <span v-if="itemSn == '10006'">
                        3、本商品在青岛市、烟台市、威海市、日照市内中石化加油站暂时无法提货。
                    </span>
                </p>
                <h4>客服电话：</h4>
                 <p>
                    售后问题请致电400-966-9058
                </p>
            </div>
        </div>
        <!-- <div @click="goOrder" class="shopDetailFooter">会员尊享价￥{{}}sppna</div> -->
        <div @click="goOrder" class="shopDetailFooter">会员尊享价￥{{(itemInfo.salerPrice/100).toFixed(2)}}<s>(原价￥{{(itemInfo.price/100).toFixed(2)}})</s></div>
    </div>
</template>
<script>
import common from '@/util/common';
export default {
    data() {
        return {
            eqID: 0,
            value: '',
            itemInfo: [],
            swiper: [],
            itemSn: '',
            token: '',
            mbrProdType: '',
            getPhoneNum: '',
            itemInfo: {},
            weixin: false,
            noweixin: false,
            type: ''
        }
    },
    mounted() {
        this.itemSn = this.$route.query.itemSn
        this.mbrProdType = this.$route.query.mbrProdType
        this.token = this.$route.query.token
        let ua = window.navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            this.type = '2'
            this.weixin = true
            this.noweixin = false
        } else {
            this.type = '1'
            this.noweixin = true
            this.weixin = false
        }
        this.getPhone()
        this.init()
    },
    methods: {
        //获取用户手机号
        getPhone(){
            this.$axios({
                method: 'post',
                url: this.GLOBAL.pro + '/shop/etcplatform/getPlatformUser?token='+ this.token,
                headers: {
                    "Content-Type": "application/json", //设置请求头请求格式为JSON
                    'token': this.token
                },
            }).then(res => {
                if(res.data.result) {
                    this.getPhoneNum = res.data.result.phone
                } else {
                    this.getPhoneNum = ''
                }
            }).catch(e => {
                console.log(e);
            });
        },
        //去订单信息页
        goOrder() {
            if(this.getPhoneNum != '') {

                  this.$axios({
                      method: 'post',
                      url: this.GLOBAL.pro + '/shop/sdorder/orderInit?itemSn='+ this.itemSn +'&token=' + this.token,
                      headers: {
                          "Content-Type": "application/json", //设置请求头请求格式为JSON
                          'token': this.token
                      },
                  }).then(res => {
                      var orderNo = res.data.result.orderNo
                      this.itemInfo = res.data.result.itemInfo
                      var userInfo = 'orderNo=' + orderNo +'&token=' + this.token + '&type=' + this.type + '&phone=' + this.getPhoneNum
                      this.$cookies.set('userInfo', JSON.stringify(userInfo))
                      if(this.type == 2) {
                          this.codeInfo = this.$route.query.code;
                          if (!this.codeInfo) {
                              // var url = encodeURIComponent('http://dev.win-credit.com/shanDongcs/index.html#/orderDetail')
                              // window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx36838df89d89b4be&redirect_uri='+url+'&response_type=code&scope=snsapi_base&connect_redirect=1#wechat_redirect';
                              var url = encodeURIComponent('http://m.win-credit.com/shanDong/index.html#/orderDetail')
                              window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx36838df89d89b4be&redirect_uri='+url+'&response_type=code&scope=snsapi_base&connect_redirect=1#wechat_redirect';
                              this.codeInfo = this.$route.query.code;
                          }

                      } else {
                          this.$router.push('/orderDetail?orderNo=' + orderNo +'&token=' + this.token + '&type=' + this.type)
                      }
                  }).catch(e => {
                      console.log(e);
                  });

            } else {
                common.toast('没有购买权限!!!')
            }

        },
        //初始页面获取数据
        init() {
            this.$axios({
                method: 'post',
                url: this.GLOBAL.pro + '/shop/sditeminfo/getItemInfo?itemSn='+ this.itemSn,
                headers: {
                    "Content-Type": "application/json", //设置请求头请求格式为JSON
                    'token': this.token
                },
            }).then(res => {
                this.itemInfo = res.data.result.itemInfo
                this.swiper = res.data.result.swiper
            }).catch(e => {
                console.log(e);
            });
        },
        //返回
        goBack() {
            history.go(-1)
        },
        //规格选择
        chooseEq(index) {
            this.eqID = index
        }
    }
}
</script>
<style lang="sass">

</style>
<style lang="sass" scoped>

.shopDetailWrap
    width: 100%;
    height: 100vh;
    display: flex;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    background: #F2F2F2;
    .shopDetailHeader
        width: 100%;
        height: 0.4rem;
        background: #fff;
        text-align: center;
        line-height: 0.4rem;
        font-size: 0.15rem;
        position: relative;
        border-bottom: 1px solid #eee;
        img
            width: 0.2rem;
            height: 0.2rem;
            position: absolute;
            top: 50%;
            left: 0.1rem;
            transform: translate(0, -50%);
    .shopDetailCont
        flex: 1;
        width: 100%;
        overflow: auto;
        .swiperWrap
            width: 100%;
            height: 2rem;
        img
            width: 100%;
            height: auto;
            display: block;
        .equityChoose
            width: 100%;
            height: auto;
            background: #fff;
            margin-top: 0.1rem;
            padding: 0 0.1rem;
            p
                width: 100%;
                padding-top: 0.1rem;
                font-size: 0.15rem;
                font-weight: bolder;
            >ul
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                margin-top: 0.1rem;
                li
                    padding: 0.02rem 0.1rem;
                    margin-right: 0.1rem;
                    font-size: 0.13rem;
                    border-radius: 0.03rem;
                    margin-bottom: 0.1rem;
                    border: 1px solid #29B773;
        .equityZF
            width: 100%;
            height: auto;
            background: #fff;
            margin-top: 0.1rem;
            .cs,.wxs
                display: flex;
                flex: 1;
                position: relative;
                line-height: 0.5rem;
                img
                    height: 0.35rem;
                    width: auto;
                    display: block;
                    width: auto;
                    margin: 0.07rem 0.1rem 0.07rem 0.1rem;
                p
                    width: 80%;
                input[type="radio"]
                    width: 0.2rem;
                    height: 0.2rem;
                    opacity: 0;
                label
                    position: absolute;
                    right: 0.2rem;
                    top: 0.15rem;
                    width: 0.2rem;
                    height: 0.2rem;
                    border-radius: 50%;
                    border: 1px solid #999;
                    cursor: pointer;
                input:checked+label
                    background-color: #00A0E9;
                    border: 1px solid #00A0E9;
                input:checked+label::after
                    position: absolute;
                    content: "";
                    width: 0.05rem;
                    height: 0.1rem;
                    top: 0.015rem;
                    right: 0.05rem;
                    border: 0.02rem solid #fff;
                    border-top: none;
                    border-left: none;
                    transform: rotate(45deg);
            .wxs
                input:checked+label
                    background-color: #29B773;
                    border: 1px solid #29B773;
        .eqInfo
            width: 100%;
            height: auto;
            background: #fff;
            margin-top: 0.1rem;
            padding: 0 0.15rem;
            >h4
                font-size: 0.14rem;
                font-weight: bold;
                line-height: 0.3rem;
                padding-top: 0.1rem;
            >p
                font-size: 0.13rem;
                line-height: 0.2rem;
                span
                    display: block;
                    margin-top: 0.05rem;
    .shopDetailFooter
        width: 100%;
        height: 0.5rem;
        background: #29B773;
        color: #333;
        font-weight: bolder;
        line-height: 0.5rem;
        text-align: center;
        font-size: 0.18rem;
        s
            font-size: 0.13rem;
</style>



// WEBPACK FOOTER //
// src/page/shopDetail.vue